// @flow
import React from 'react';
import styled from 'styled-components';
import * as _ from "lodash";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import moment from 'moment/moment';
import type { TPlayerWithFixture, TCoachPlayerStatsById } from '../../modules/types/player';
import { isMobile } from '../../utils';
import { basic_player_stats, coach_player_stats } from '../../helpers/stats';
import Table, { TBody, THead, Tr, Th, Td } from '../TableX';
import ArrowUp from '../Icons/ArrowUp';
import ArrowDown from '../Icons/ArrowDown';
import {
	CoachLockIcon,
} from '../../components';
import T from '../Icons/T';
import FA from '../Icons/FA';
import D from '../Icons/D';
import {
	PageTitle,
	PlayerInfo,
	DraftFilters,
	ButtonLoadMore,
	DraftTableHeader,
	ThStat
} from '../';
import PlayerProfilePopup from '../PlayerProfilePopup';
import ThToolTip from '../ThToolTip';
import * as selectors from "../../modules/selectors";
import type {
	TCoachStatsListReducer,
	TPlayerStatusesReducer, TPosition, TRootStore,
	TSquad,
} from "../../modules/types";
import * as actions from "../../modules/actions";
import colors from "../../assets/css/colors";
import Lock from '../Icons/Padlock';
import TeamName from './teamName';
import UserName from './userName';
import TradeButtonsWrapper from './tradeButtonsWrapper';
import TradeButton from './tradeButton';

const Expander = styled.div`
	padding: 5%;
	width: 100%;
	text-align: center;
`;

const TdStat = styled(Td)`
	position: relative;
	color: ${colors.title};
	&.active {
		background: ${colors.active_stats};
	}
`;

const OwnershipSpan = styled.span`
	&.color1{
		color: green;
	}
	&.color-1{
		color: red;
	}
`;

const THeadStyled = styled(THead)`
	&.coach-stats{
		background: ${colors.coachPurple};
	}
`;

const TdYourTeam = styled(Td)`
	padding: 0;
	padding-right: 5px;

	&:first-child {
		padding-left: 0;
	}
`;

const PageTitleStyled = styled(PageTitle)`
	margin: 1.5em 0 .5em 0;
`;

const MobileScroll = styled.div`
	max-width: 100%;
	overflow: auto;
`;

type TableColumns = Array<{
	key: string, prop: string,
	tooltip?: string, is_fc?: boolean, is_owner_display?: boolean
}>;

type Props = {
	match: Object,
	league: Object,
	// teams_by_id: Object,
	players: Array<TPlayerWithFixture>,
	fetchWaiverList: typeof actions.leagueDraft.fetchWaiverList,
	fetchWaiverFree: typeof actions.leagueDraft.fetchWaiverFree,
	is_pending_players: boolean,
	positions: Array<TPosition>,
	squads: Array<TSquad>,
	playerStatuses: TPlayerStatusesReducer,
	actual_round: Object,
	last_round: Object,
	table: {
		basic: TableColumns,
		coach: Object,
	},
	coach_stats_list: TCoachStatsListReducer,
	has_assistant_coach: boolean,
	coach_players_by_id: TCoachPlayerStatsById,
	waiver_requests: string,
	addOutTrade: Function,
	addInTrade: Function,
	cancelTradeRequest: Function,
	removeOutPlayer: Function,
	removeInPlayer: Function,
	only_fa: boolean,
	only_teams: boolean,
	is_league_started: boolean,
	addOwnerFilter?: boolean
}

type TFilters = {
	search: string,
	by_squad: string,
	by_position: string,
	by_status: string,
	by_dpp: boolean,
	by_favourites: boolean,
	by_drafted: boolean,
	by_fa: boolean
}

type State = {
	//	order_by_desc: boolean,
	filters: TFilters,
	sort_by?: string,
	order_by_desc?: boolean,
	players_show_limit?: number,
	players_show_limit_step?: number,
	player_row_menu_ids: Array<number>,
	is_coach_active: boolean,
	coach_type: string,
	fa_trade: {
		new_player_id: number,
		old_player_id: number
	},
	team_trade: {
		new_player_id: Array<number>,
		old_player_id: Array<number>
	},
	is_fa_trade: boolean,
	is_team_trade: boolean,
	show_team: boolean,
	popup_player: number | null,
};

class PlayersComponent extends React.Component<Props, State> {

	state = {
		players_show_limit: 20,
		players_show_limit_step: 20,
		sort_by: 'stats.avg_points',
		order_by_desc: true,
		player_row_menu_ids: [],
		filters: {
			search: '',
			by_squad: '',
			by_position: '',
			by_status: '',
			by_dpp: false,
			by_owner: 'fa_rfa',
			by_favourites: false,
			by_drafted: false,
			by_fa: false
		},
		is_coach_active: false,
		coach_type: 'coaches-choice',
		fa_trade: {
			new_player_id: 0,
			old_player_id: 0
		},
		team_trade: {
			new_player_id: [],
			old_player_id: []
		},
		is_fa_trade: false,
		is_team_trade: false,
		show_team: false,
		popup_player: null,
	};

	static defaultProps = {
		players: [],
		waiver_requests: ''
	};

	filterChecker(is_what, what) {
		return is_what ? what : _.identity;
	}

	get table_keys() {

		const { is_coach_active, coach_type } = this.state;
		return is_coach_active ?
			_.get(this.props, `table.coach[${coach_type}]`, [])
				.filter(table_key => table_key.hide !== true) :
			_.get(this.props, 'table.basic[basic]', [])
				.filter(table_key => table_key.hide !== true);
	}

	setCoachType(event) {
		const { value } = event.target;
		this.setState({ coach_type: value });
	}

	/**
	 * Handle search and filters
	 */
	onFiltersChange(event) {
		const { filters } = this.state;
		const {
			order_by_desc,
			...rest_filters
		} = this.formElementToKeyValueObject(event.currentTarget);

		this.setState({
			order_by_desc,
			filters: {
				...filters,
				...rest_filters
			}
		});
	}

	onSearchSubmit(event) {
		event.preventDefault();
	}

	formElementToKeyValueObject(form) {
		return Array.from(form.elements).reduce(this.accumulateFormInputsValueByName, {});
	}

	accumulateFormInputsValueByName(accumulator: Object, formElement: Object) {
		const { type, name, checked, value } = formElement;

		if (_.eq(type, 'submit')) {
			return accumulator;
		}

		if (!name) {
			throw new Error('All form inputs should be have "name" attribute!');
		}

		accumulator[name] = _.eq(type, 'checkbox') ? checked : value;

		return accumulator;
	}

	constructor(props, state) {
		super(props, state);

		_.bindAll(this, [
			'onFiltersChange',
			'onSearchSubmit',
			'onLoadMoreClick',
			'onTabChange',
			'setCoachType',
			'getPlayerRowButtons',
			'filterChecker',
			'handleCoachSelectChange',
			'orderByComparator',
			'openPopup',
			'closePopup',
		]);
	}

	openPopup(id: number) {
		this.setState({
			popup_player: id,
		});
	}

	closePopup() {
		this.setState({
			popup_player: null,
		});
	}

	onTabChange(event) {
		const { is_coach_active } = this.state;
		this.setState({ is_coach_active: !is_coach_active });
	}

	isActiveTab(sort_prop) {
		const { sort_by } = this.state;
		return _.eq(sort_by, sort_prop) ? 'active' : '';
	}
	handleCoachSelectChange(event) {
		const { value: coach_type } = event.target;
		this.setState({ coach_type });
	}
	onSortColumnChange(column_value) {
		const { sort_by, order_by_desc } = this.state;

		this.setState({
			sort_by: column_value,
			order_by_desc: _.eq(sort_by, column_value) ? !order_by_desc : order_by_desc,
		});
	}

	get table_header() {
		const { last_round: { id } } = this.props;
		const { order_by_desc } = this.state;
		const getKey = ({ key, id }) => {
			if (key === 'RD X Score' && id) {
				return `RD ${id} Score`;
			}
			return key;
		};
		const cells = this.table_keys.map(({ key, prop, tooltip }) => (
			<ThStat
				className={this.isActiveTab(prop)}
				onClick={() => this.onSortColumnChange(prop)} key={key}>
				<div className="highlighter" />
				<div>
					<span className="column-name">
						{getKey({ key, id })}
					</span>
					{this.isActiveTab(prop) && !order_by_desc ?
						<ArrowUp color='#ffffff' className='top' /> : null}
					{this.isActiveTab(prop) && order_by_desc ?
						<ArrowDown color='#ffffff' className="down" /> : null}
					{tooltip && <ThToolTip text={tooltip} />}
				</div>
			</ThStat>
		));

		const { is_coach_active } = this.state;

		return (
			<THeadStyled className={is_coach_active ? 'coach-stats' : 'basic-stats'} >
				<Tr>
					<Th textAlign="left">All Players</Th>
					<Th textAlign="left">{isMobile() ? 'Own' : 'Owner'}</Th>
					{cells}
					<ThStat width="100px">
						Action
						<ThToolTip text='Click for Action' />
					</ThStat>
				</Tr>
			</THeadStyled>
		);
	}

	get has_filters() {
		const { only_fa } = this.props;
		return only_fa || _.size(_.values(this.state.filters).filter(_.identity));
	}

	get players_filter() {
		const { only_fa } = this.props;
		const { filters } = this.state;
		const {
			by_status,
			by_squad,
			by_favourites,
			by_position,
			by_dpp,
			by_owner,
			by_fa,
			search
		} = filters;
		const is_by_fa = only_fa || by_fa;

		const by_owned = by_owner === 'owned';
		const by_rfa = by_owner === 'rfa';
		const by_fa_rfa = by_owner === 'fa_rfa';

		const byPlayerStatus = _.matches({ status: by_status });

		const bySquadId = _.matches({ squad_id: parseInt(by_squad, 10) });

		const byFavourites = _.property('is_favourite');

		const byPosition = _.flow([
			_.property('positions'),
			_.partial(_.includes, _, parseInt(by_position, 10))
		]);

		const byDPP = ({ positions }) => _.eq(_.size(positions), 2);

		const byName = (({ first_name, last_name }) => (
			`${first_name} ${last_name}`.toLowerCase().includes(search.toLowerCase())
		));

		const byFA = ({ owner }) => !owner;
		const byRFA = _.property('expiry');
		const byFA_RFA = byFA;
		const byOWNER = _.property('owner');

		return _.overEvery([
			this.filterChecker(by_status, byPlayerStatus),
			this.filterChecker(by_squad, bySquadId),
			this.filterChecker(by_favourites, byFavourites),
			this.filterChecker(by_position, byPosition),
			this.filterChecker(by_dpp, byDPP),
			this.filterChecker(by_rfa, byRFA),
			this.filterChecker(by_fa_rfa, byFA_RFA),
			this.filterChecker(by_owned, byOWNER),
			this.filterChecker(is_by_fa, byFA),
			this.filterChecker(search, byName),
		]);
	}

	orderByComparator(player_one, player_two) {
		const
			{ sort_by, order_by_desc } = this.state,
			order = order_by_desc ? 1 : -1,
			boundary_value = Number.MAX_SAFE_INTEGER * order,
			inverted_boundary_value = boundary_value * -1,
			inverted_pre_boundary_value = inverted_boundary_value + order,
			getResult = (condition, min, value) => condition(value) ? min : value,
			isStringOrZero = val => _.isString(val) || _.eq(val, 0),
			getResultOrMin = _.partial(getResult, isStringOrZero, inverted_pre_boundary_value),
			getSafeValueToCompare = value => (
				_.isUndefined(value) ? inverted_boundary_value : getResultOrMin(value)
			),
			a_result = getSafeValueToCompare(_.get(player_one, sort_by)),
			b_result = getSafeValueToCompare(_.get(player_two, sort_by)),
			is_bigger = a_result < b_result,
			is_less = a_result > b_result;

		if (is_bigger) {
			return order;
		}

		if (is_less) {
			return -1 * order;
		}

		return 0;
	}

	get players_unsliced() {
		const { players, only_fa } = this.props;
		const players_copy = players.slice();

		if (only_fa) {
			return players_copy
				.filter(this.players_filter)
				.sort(this.orderByComparator);
		}

		if (this.has_filters) {
			return players_copy
				.filter(this.players_filter)
				.sort(this.orderByComparator);
		}

		return players_copy
			.sort(this.orderByComparator);
	}

	get players() {
		const { players_show_limit } = this.state;
		console.log(this.players_unsliced.slice(0, players_show_limit));
		return this.players_unsliced.slice(0, players_show_limit);
	}

	getTableMessage(message) {
		return (
			<TBody>
				<Tr>
					<Td align="center" colSpan={_.size(this.table_keys) + 3}>
						<Expander>{message}</Expander>
					</Td>
				</Tr>
			</TBody>
		);
	}

	get table_body() {
		const { is_pending_players, has_assistant_coach } = this.props;

		if (is_pending_players) {
			return this.getTableMessage('Loading, please wait...');
		}

		const players_list = this.players;

		if (!is_pending_players && _.isEmpty(players_list)) {
			return this.getTableMessage(
				'No Players within the player pool fit your search criteria'
			);
		}

		const cells = players_list.map(player => {
			const { draft_order } = player;
			const is_ignored = !draft_order;

			return (
				<Tr className={is_ignored ? 'is-ignored' : null} key={player.id}>
					<TdYourTeam textAlign="left">
						<PlayerInfo
							className="player-info"
							player={player}
							longer_name
							openPopup={this.openPopup}
							closePopup={this.closePopup}
						/>
					</TdYourTeam>
					{player.owner ? (
						<TdStat textAlign="left">
							<TeamName>{player.owner.name}</TeamName>
							<UserName>{player.owner.firstname} {player.owner.lastname}</UserName>
						</TdStat>
					) : (
						<TdStat textAlign="left">
							<TeamName>{isMobile()
								? player.waiver_mobile : player.waiver}</TeamName>
							{player.expiry ? (
								<UserName>{moment(player.expiry)
									.format(isMobile() ? 'Do MMM h:mma' : 'MMMM Do h:mma')}</UserName>
							) : null}
						</TdStat>
					)}
					{this.table_keys.map(({ key, prop, prop_sub, is_owner_display, is_fc }) => {
						const renderValue = () => (
							<React.Fragment>
								{_.get(player, prop, '--')} {prop_sub
									? `(${_.get(player, prop_sub, '--')})`
									: null
								}
							</React.Fragment>
						);
						return (
							<TdStat className={`player-stats ${this.isActiveTab(prop)}`} key={key}>
								{is_fc && !has_assistant_coach ? (
									<CoachLockIcon />
								) : (is_owner_display ?
									<OwnershipSpan
										className={`color${Math.sign(_.get(player, prop, '--'))}`}>
										{renderValue()}
									</OwnershipSpan> : renderValue()
								)}
							</TdStat>
						);
					})}
					<TdStat>
						{this.getPlayerRowButtons(player)}
					</TdStat>
				</Tr>
			);
		});

		return <TBody>{cells}</TBody>;
	}

	getPlayerRowButtons(player) {
		const { id, owner, is_user_team, waiver } = player;
		const data_for_trade = {
			id,
			is_user_team,
			owner,
			waiver,
			is_fa: false
		};
		const is_trade_locked = !this.checkIsManagementAvailable(id);

		if (is_trade_locked) {
			return <TradeButtonsWrapper>
				<TradeButton onClick={() => null}>
					<Lock color={colors.icon_grey} width={'100%'} height={'100%'} />
				</TradeButton>
			</TradeButtonsWrapper>;

		}

		if (is_user_team) {
			return (
				<TradeButtonsWrapper>
					<TradeButton
						is_shadow
						onClick={() => this.props.addOutTrade(data_for_trade)}
					>
						<T />
					</TradeButton>
					{is_trade_locked ? <TradeButton onClick={() => null}>
						<Lock color={colors.icon_grey} />
					</TradeButton> : (
						<TradeButton
							onClick={() => this.props.addOutTrade({
								...data_for_trade,
								is_fa: true
							})}
							color={colors.negative_value}
							border={colors.negative_value}
						>
							<D color={colors.negative_value} />
						</TradeButton>
					)}
				</TradeButtonsWrapper>
			);
		}

		if (owner) {
			return (
				<TradeButtonsWrapper>
					<TradeButton
						is_shadow
						onClick={() => this.props.addInTrade(data_for_trade)}
					>
						<T />
					</TradeButton>
				</TradeButtonsWrapper>
			);
		}

		return (
			<TradeButtonsWrapper>
				<TradeButton
					background={colors.lightGrey}
					onClick={() => this.props.addInTrade(data_for_trade)}
				>
					<FA size="1.375" />
				</TradeButton>
			</TradeButtonsWrapper>
		);
	}

	checkIsManagementAvailable(player_id) {
		const { actual_round, players, league } = this.props,
			{ status } = actual_round,
			{ status: league_status, lockout } = league,
			player = _.find(players, { id: player_id });

		if (league_status === 'scheduled') {
			return true;
		}

		if (!lockout && status !== 'scheduled') {
			return false;
		}

		return player && !player.locked;
	}

	onLoadMoreClick() {
		const { players_show_limit, players_show_limit_step } = this.state;

		this.setState({
			players_show_limit: players_show_limit + players_show_limit_step,
		});
	}

	get load_more_btn() {
		// const { players, is_pending_players, only_fa } = this.props;
		// const { players_show_limit } = this.state;

		// if(is_pending_players ||
		// 	(this.has_filters && !only_fa) ||
		// 	_.gt(players_show_limit, _.size(players))
		// ) {
		// 	return null;
		// }

		if (this.players.length >= this.players_unsliced.length) {
			return null;
		}

		return <ButtonLoadMore onClick={this.onLoadMoreClick}>
			Load More <ArrowDown />
		</ButtonLoadMore>;
	}

	renderPlayerPopup() {
		const { popup_player } = this.state;
		const { players } = this.props;

		if (popup_player) {
			return <PlayerProfilePopup
				player={_.find(players, { id: popup_player })}
				closeClick={this.closePopup}
			/>;
		}

		return null;
	}

	render() {
		const {
			squads,
			positions,
			playerStatuses,
			league,
			coach_stats_list,
			league: { trade_waivers },
			addOwnerFilter
		}
			= this.props;

		const {
			is_coach_active,
			order_by_desc
		} = this.state;

		const hide_rfa = !trade_waivers;
		return (
			<React.Fragment>
				{this.renderPlayerPopup()}
				<PageTitleStyled>
					Player List for {league.name}
				</PageTitleStyled>
				<DraftFilters
					handleChange={this.onFiltersChange}
					handleSubmit={this.onSearchSubmit}
					squads={squads}
					positions={positions}
					statuses={playerStatuses}
					hide_rfa={hide_rfa}
					is_hide_sort={false}
					order_by_desc={order_by_desc}
					is_show_owner={addOwnerFilter}
				/>
				<DraftTableHeader
					onTabClick={this.onTabChange}
					isCoachActive={is_coach_active}
					selectOptions={coach_stats_list}
					setCoachType={this.setCoachType}
					onSelectChange={this.handleCoachSelectChange}
				/>
				<MobileScroll>
					<Table>
						{this.table_header}
						{this.table_body}
					</Table>
				</MobileScroll>
				{this.load_more_btn}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: TRootStore, props) => {
	const actual_round = selectors.rounds.getActualRound(state);
	const actual_round_id = _.get(actual_round, 'id', 0);
	const is_preseason = actual_round ? actual_round_id < 2 : false;
	const rounds = selectors.rounds.getRounds(state);
	let stats_table_round_id = 1;
	if (!!rounds.length) {
		stats_table_round_id = is_preseason ? _.last(rounds).id :
			(actual_round.status === 'active' ? actual_round_id + 1 : actual_round_id);
	}

	return {
		players: selectors.players.getExtendedPlayersArrayWithOwners(state, props),
		is_pending_players: state.players.is_pending,
		actual_round,
		squads: selectors.squads.getSquads(state),
		positions: selectors.positions.getPositionsArray(state),
		playerStatuses: state.playerStatuses,
		last_round: selectors.rounds.getLastRound(state),
		// teams_by_id: state.leagues.teams_by_id,
		has_assistant_coach: Boolean(selectors.getUser(state).assistant_coach),
		coach_stats_list: state.coachStatsList,
		coach_players_by_id: state.players.coach_by_id,
		is_league_started: selectors.leagueDraft.isLeagueStarted(state, props),
		table: {
			basic: _.mapValues(basic_player_stats(stats_table_round_id, is_preseason), values => _
				.map(values, value => {
					return {
						...value,
					};
				})),
			pre_draft_list_size: 0,

			coach: _.mapValues(coach_player_stats(stats_table_round_id, is_preseason), values => _
				.map(values, value => {
					return {
						...value,
						is_fc: true
					};
				}))
		}
	};
};

const mapDispatchToProps = {
	fetchWaiverList: actions.leagueDraft.fetchWaiverList,
	fetchWaiverFree: actions.leagueDraft.fetchWaiverFree,
};

export const PlayersTable = withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps,
	)(PlayersComponent)
);
export default PlayersTable;


// WEBPACK FOOTER //
// ./src/components/PlayersTable/index.js